const csrPageData = {
    headerImage : {
        name : "csr.jpg",
        alt : "Our corporate social responsibility",
    },
    mainTitle : "Our Corporate Social Responsibility Policy ",
    paragraphOne : "As a major financial institution, we know we have a responsibility to contribute to the wellbeing of the communities in which we operate. We have in place a Corporate Social Responsibility Policy that guides our social investments. SAB, as a major financial institution, is privileged to be able to fund and participate in philanthropical initiatives. SAB’s contribution to communities is an important part of our approach to sustainability.",
    boxOne : {
        title : "Impact-based philanthropic agenda",
        subtitle : "In 2022, we refined our CSR Policy to ensure that every Riyal spent has maximum impact for our communities over the long-term, while aligning to our purpose as an organisation. We reviewed the policy with input from our strategic partners HSBC, taking into account local context and international best practices. SAB’s ESG Steering Committee provides governance and management oversight of CSR and the donation funds, to ensure maximum impact for every Riyal spent for philanthropic related activities. The Shariah team also provides input into our CSR projects.",
    },
    boxTwo : {
        title : "Strategic CSR focus areas",
        subtitle : "Our CSR spend is focused on 2 key areas.",
    },
    cards : [
        {
            title : "Education",
            subtitle : "Education is key to achieving prosperity. Through our education initiatives, we contribute to the personal development and wellbeing of young people. We focus on education programmes aimed at both children and adults of all ages within the following areas:",
            list : [
                "Programmes for disadvantaged children, or for schools in economically deprived areas ",
                "Education that raises the level of financial and business literacy in the community, especially among young people",
                "Environmental education around climate change, freshwater, and terrestrial biodiversity",
            ],
        },
        {
            title : "Environment",
            subtitle : "The Kingdom is vulnerable to the effects of climate change. As such, we are committed to protecting the environment and supporting a healthy ecosystem for the good of all Saudi citizens. Our environmental work focuses on themes of direct relevance to our business and communities: ",
            list : [
                "Conservation of terrestrial biodiversity and habitats (including forests) ",
                "Causes and effects of climate change ",
                "Freshwater sustainability",
            ],
        },
    ],
    paragraphTwo : "SAB may also, at the discretion of the Steering Committee, commit funds to other philanthropic activities that align with the ESG strategy.”",
    boxThree : {
        title : "CSR project criteria",
        subtitle : "Each new social responsibility initiative must:",
    },
    list : [
        "Bring lasting benefit to the local community ",
        "Motivate staff through opportunities for direct involvement where possible",
        "Benefit the people and communities in which SAB has a presence ",
        "Focus on education or the environment wherever possible",
    ],
    paragraphThree : "To ensure appropriate governance of our philanthropic activities, our ESG Steering Committee is also responsible for ensuring that donations to charitable organisations are reputable, registered with the Ministry of Labour and Social Development, and able to show tangible impact.",
};

export default csrPageData;